import React from 'react';
import { Popover, Typography, IconButton, Box, Divider, Grid } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PersonIcon from '@mui/icons-material/Person';
import EventIcon from '@mui/icons-material/Event';
import FlagIcon from '@mui/icons-material/Flag';
import WorkIcon from '@mui/icons-material/Work';
import DescriptionIcon from '@mui/icons-material/Description';

const getFormattedDate = (date = new Date()) => date.toISOString().split('T')[0];

const isTodayOrTomorrow = (dateString) => {
    const todayStr = getFormattedDate();
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const tomorrowStr = getFormattedDate(tomorrow);

    return dateString === todayStr || dateString === tomorrowStr;
};

const LineItem = ({ icon, label, value }) => (
    <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '95%',
        mx: 'auto',
        py: 0.75,
    }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {icon}
            <Typography sx={{ fontWeight: '500', fontSize: '14px', color: '#444' }}>
                {label}:
            </Typography>
        </Box>
        <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#000' }}>
            {value || 'N/A'}
        </Typography>
    </Box>
);

const TaskPopover = ({ anchorEl, open, handleClose, eventData, onEdit }) => {
    const dividerStyle = { width: '95%', mx: 'auto', borderColor: '#ddd' };
   
    const isForTodayOrTomorrow = isTodayOrTomorrow(eventData?.dueDate);

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            sx={{ boxShadow: '0px 4px 10px rgba(0,0,0,0.2)' }}
        >
            <Box sx={{ padding: '16px', width: '340px', backgroundColor: '#fff', borderRadius: '8px' }}>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, pb: 1, borderBottom: '1px solid #ddd' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '18px' }}>Task Details</Typography>
                    <IconButton onClick={onEdit} aria-label="Edit Task">
                        <EditIcon />
                    </IconButton>
                </Box>


                <Grid container spacing={0}>
                    <Grid item xs={12}><LineItem icon={<PersonIcon sx={{ color: '#1976d2' }} />} label="Assigned To" value={eventData?.assignedToName} /></Grid>
                    <Divider sx={dividerStyle} />
                    <Grid item xs={12}><LineItem icon={<EventIcon sx={{ color: '#d32f2f' }} />} label="Due Date" value={eventData?.dueDate} /></Grid>
                    <Divider sx={dividerStyle} />
                    <Grid item xs={12}><LineItem icon={<WorkIcon sx={{ color: '#7b1fa2' }} />} label="Type of Task" value={eventData?.taskType} /></Grid>
                    <Divider sx={dividerStyle} />
                    <Grid item xs={12}><LineItem icon={<FlagIcon sx={{ color: '#f57c00' }} />} label="Priority" value={eventData?.priority} /></Grid>
                    <Divider sx={dividerStyle} />
                    <Grid item xs={12}><LineItem icon={<DescriptionIcon sx={{ color: '#009688' }} />} label="Description" value={eventData?.taskDescription} /></Grid>
                    <Divider sx={dividerStyle} />


                    <Grid item xs={12}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '95%',
                            mx: 'auto',
                            py: 0.75,
                        }}>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.3, minWidth: '30%', ml: '2px' }}>
                                <Box sx={{
                                    width: 19,
                                    height: 19,
                                    borderRadius: '50%',
                                    backgroundColor: eventData?.status === 'Open' ? '#4caf50' : eventData?.status === 'Closed' ? '#f44336' : '#555',
                                    flexShrink: 0,  // Ensures the circle doesn't shrink
                                    ml: '1px'
                                }} />
                                <Typography sx={{ fontWeight: '500', fontSize: '14px', color: '#444' }}>
                                    Status:
                                </Typography>
                            </Box>

                            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#000' }}>
                                {eventData?.status || 'N/A'}
                            </Typography>
                        </Box>
                    </Grid>

                    {isForTodayOrTomorrow && (
                        <Grid item xs={12}>
                            <Box sx={{ width: '95%', mx: 'auto', py: 0.5, mt: 1, textAlign: 'center', backgroundColor: '#ffeb3b', borderRadius: 1 }}>
                                <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#000' }}>
                                    This task is for {eventData?.dueDate === getFormattedDate() ? 'Today' : 'Tomorrow'}.
                                </Typography>
                            </Box>
                        </Grid>
                    )}
                </Grid>
            </Box>
        </Popover>
    );
};

export default TaskPopover;
